export default __webpack_public_path__ + "envelope-of-white-paper.png";